import { render, staticRenderFns } from "./PhotoUpload.vue?vue&type=template&id=22be3c54&scoped=true"
import script from "./PhotoUpload.vue?vue&type=script&lang=js"
export * from "./PhotoUpload.vue?vue&type=script&lang=js"
import style0 from "./PhotoUpload.vue?vue&type=style&index=0&id=22be3c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be3c54",
  null
  
)

export default component.exports